export const baseUrl = process.env.REACT_APP_TELEMATICSERVICES_URL;
//export const baseUrl = "http://localhost:8003/services/telematics";

export const telematicsservicesUrls = {
    baseUrl: () => baseUrl,

    request: {
        baseUrl: () => `${baseUrl}`,
        logdata: () => `${telematicsservicesUrls.baseUrl()}/data/request/`
    },
    wakeup: () => `${baseUrl}/wakeup`
};
